import { CloseButton, Flex, HStack, Input, InputGroup } from "@chakra-ui/react";
import { LuSearch } from "react-icons/lu";
import { Checkbox } from "../chakra/checkbox";

interface TableControlsProps {
  showSearch?: boolean;
  searchPlaceholder?: string;
  showDisabledCheck?: boolean;
  handleSearch: (search: string) => void;
  searchValue?: string;
  onShowDisabledChange?: (showDisabled: boolean) => void;
  filters?: React.ReactNode;
  rightActions?: React.ReactNode;
}

const TableControls: React.FC<TableControlsProps> = ({
  showSearch = true,
  searchPlaceholder = "Buscar...",
  showDisabledCheck = false,
  handleSearch,
  searchValue,
  onShowDisabledChange,
  filters,
  rightActions,
}) => {
  return (
    <Flex
      p={{ base: 3, md: 4 }}
      gap={3}
      wrap="wrap"
      align="center"
      justify="space-between"
      borderBottomWidth="1px"
      borderColor="border"
    >
      <HStack gap={3} flex={1} minW={0} flexWrap="wrap">
        {showSearch && (
          <InputGroup
            startElement={<LuSearch />}
            endElement={
              searchValue ? (
                <CloseButton
                  size="xs"
                  aria-label="Limpiar búsqueda"
                  onClick={() => handleSearch("")}
                />
              ) : undefined
            }
            w="full"
            maxW="380px"
            flex="1 1 240px"
          >
            <Input
              placeholder={searchPlaceholder}
              value={searchValue ?? ""}
              onChange={(e) => handleSearch(e.target.value)}
            />
          </InputGroup>
        )}
        {filters}
      </HStack>

      <HStack gap={3} flexWrap="wrap">
        {showDisabledCheck && (
          <Checkbox
            colorPalette="brand"
            onCheckedChange={(e) => onShowDisabledChange?.(e.checked === true)}
          >
            Mostrar deshabilitados
          </Checkbox>
        )}
        {rightActions}
      </HStack>
    </Flex>
  );
};

export default TableControls;
